import { InjectionToken } from "@angular/core";

export interface AccountConfig {
  noAuthRedirectToUrl: string;
}

export const ACCOUNT_CONFIG = new InjectionToken<AccountConfig>(
  "ACCOUNT_CONFIG"
);
